import React from 'react';

import PropTypes from 'prop-types';
import Spinner from '@tds/core-spinner';

import { Backdrop, ModalMain, ModalInner, ModalMessageMain } from './css';

const WlsLoader = ({ message }) => {
  return (
    <Backdrop>
      <ModalMain>
        <ModalInner>
          <ModalMessageMain>
            <Spinner spinning label={message} />
          </ModalMessageMain>
        </ModalInner>
      </ModalMain>
    </Backdrop>
  );
};

WlsLoader.propTypes = {
  message: PropTypes.string.isRequired
};

export default WlsLoader;
